import { NoDataException } from '../../../utils/exceptions/nodataexistsexception';
import { FlashMessageSubscriptionDetailsDto, FlashMessageSubscriptionDetailsDtoImpl } from './flashmessagedetails';

export class FlashMessageSubscriptionBuilder
{
    constructor(private flashMessageList: any)
    {
        if(flashMessageList === undefined)
        {
            throw new NoDataException("FlashMessage data doesnt exists");
        }
    }

    buildAll(): FlashMessageSubscriptionDetailsDto
    {
        return this.parseFlashMessageDetailsResponse();
    }
    
    private parseFlashMessageDetailsResponse(): FlashMessageSubscriptionDetailsDto
    {  
        let flashmessagedto = new FlashMessageSubscriptionDetailsDtoImpl();

        if(this.flashMessageList.offers === undefined)
        {
            flashmessagedto.setStatus("A");
            flashmessagedto.setIsNewUser(true);
        }
        else
        {
            flashmessagedto.setPlanName(this.flashMessageList.offers[0].offer);
            flashmessagedto.setExpiryDate(this.flashMessageList.offers[0].nextBillingDate);
            flashmessagedto.setStatus(this.flashMessageList.offers[0].status);
            flashmessagedto.setIsNewUser(false);
        }
       
         
        return flashmessagedto;
    }
}




// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/dto/flashsubscriptiondetails/flashmessagesubscriptionbuilder.ts